<template>
  <div class="listOrSingle">
    <Banners page="ticket" />
    <EventList :isHome="isHome" v-if="eventId === null" />
    <Event :isHome="isHome" v-if="eventId !== null" :exhibitionId="eventId" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EventList from './EventList.vue';
import Event from './Event.vue';
import Banners from '../Banners/Banners.vue';

export default {
  name: 'EventListOrSingle',
  components: { EventList, Event, Banners },
  data() {
    return {
      eventId: null,
    };
  },
  methods: {
    ...mapActions({
      getList: 'tickets/getList',
    }),
  },
  computed: {
    ...mapState({
      eventList: (state) => state.tickets.data.events,
    }),
  },
  props: {
    exhibitionId: { default: null },
    isHome: { default: null },
  },
  mounted() {
    this.getList()
      .then(() => {
        const eventKeys = Object.keys(this.eventList);
        if (eventKeys.length === 1) {
          [this.eventId] = eventKeys;
        }
      })
      .catch(() => {});
  },
};
</script>

<style lang="scss" scoped></style>
